module.exports = __webpack_public_path__ + "img/umg-logo.05f374b1.png";